import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { MenuItem, ListItemText, Typography } from '@material-ui/core';

import { ContextMenu } from 'src/components/ContextMenu';
import useStyles from './useStyles';

export const WorkspaceMenuItem = ({
  classes,
  workspace,
  selected,
  onClick,
  onEditClick,
  onDeleteClick,
  disableRemoval,
}) => {
  const styles = useStyles({ classes });

  const handleClick = useCallback(() => {
    onClick(workspace);
  }, [workspace, onClick]);

  const contextMenuItems = useMemo(
    () => [
      {
        id: 'edit',
        label: 'Edit Workspace',
        onClick: () => onEditClick(workspace),
      },

      {
        id: 'delete',
        label: 'Delete Workspace',
        onClick: () => onDeleteClick(workspace),
        disabled: selected || disableRemoval,
      },
    ],
    [onDeleteClick, onEditClick, workspace, selected, disableRemoval]
  );

  return (
    <MenuItem
      className={cx(styles.root, {
        [styles.selected]: selected,
      })}
      onClick={handleClick}
      data-testid="WorkspaceMenuItem"
    >
      <Typography className={styles.first}>{workspace.name.charAt(0)}</Typography>
      <ListItemText
        classes={{
          primary: cx(styles.text),
        }}
        primary={workspace.name}
      />
      <ContextMenu
        className={styles.menuButton}
        items={contextMenuItems}
      />
    </MenuItem>
  );
};

WorkspaceMenuItem.propTypes = {
  classes: PropTypes.shape(),
  workspace: PropTypes.shape().isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  disableRemoval: PropTypes.bool,
};
WorkspaceMenuItem.defaultProps = {
  classes: null,
  selected: false,
  disableRemoval: false,
};
